<!-- 重置密码弹出层组件 -->
<template>
  <div class="repassword">
    <div class="oneLine">
      <p class="title">{{language.user}}</p>
      <p class="text">{{user.showName}}</p>
    </div>

    <div class="oneLine">
      <p class="title">{{language.account}}</p>
      <p class="text">{{user.username}}</p>
    </div>

    <div class="part pwd">
      <div class="title">{{language.setpw}}</div>
      <Input :type="password1" v-model="password" :placeholder="language.toastInputPw" />
      <div :class="'eye '+password1"><img @click="change(1)" class="yes" src="../assets/login/password_eye.png"><img @click="change(2)" class="no" src="../assets/login/password_eye_closed.png"></div>
    </div>
    <div class="part pwd">
      <div class="title">{{language.confirmPw}}</div>
      <Input :type="password2" v-model="passwordAgain" :placeholder="language.toastConfirmPw" />
      <div :class="'eye '+password2"><img @click="change(3)" class="yes" src="../assets/login/password_eye.png"><img @click="change(4)" class="no" src="../assets/login/password_eye_closed.png"></div>
    </div>

    <div class="formBtn">
      <Button type="primary" @click="edit()">{{language.buttonConfirm}}</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'repassword',
  props: ['user'],
  data() {
    return {
      language: this.$store.state.language, // 语言
      password: '',// 密码
      passwordAgain: '',// 确认密码
      password1: 'password',// 密码1输入框类型
      password2: 'password',// 密码2输入框类型
    };
  },
  methods: {
    // 改变密码明文状态
    change: function(i){
      switch (i) {
        case 1:
          this.password1 = 'password';
          break;
        case 2:
          this.password1 = 'text';
          break;
        case 3:
          this.password2 = 'password';
          break;
        case 4:
          this.password2 = 'text';
          break;
      }
    },
    // 修改密码
    edit: function() {
      var reg = /[a-zA-Z0-9]{8,12}/;
      if (this.password.length == 0) {
        this.$Message.error(this.language.toastInputPw);
        return false;
      }
      if (!reg.test(this.password)||this.password.length>12) {
        this.$Message.error(this.language.toastErrorPw);
        return false;
      }
      if (this.passwordAgain.length == 0) {
        this.$Message.error(this.language.toastConfirmPw);
        return false;
      }
      if (this.passwordAgain != this.password) {
        this.$Message.error(this.language.toastErrorConfirmPw);
        return false;
      }
      var params = { password: this.password, username: this.user.username };
      this.$post('/member/setPassword', params, 1).then(res => {
        this.$Message.success(this.language.resetPasswordS);
        this.$parent.$parent.selectId = [];
        this.$parent.$parent.isShowReset = false;
        this.$emit('success')
      }).catch(err => {
        this.$Message.error(this.language.resetPasswordF);
      });
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
.part {
  margin-bottom: 30px;
  width: 100%;
  position: relative;
}

.title {
  font-size: 14px;
  color: #181E24;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.oneLine{
  margin-bottom: 30px;
}

.text{
  font-weight: bold;
  color: rgba(24, 30, 36, 1);
  font-size: 16px;
}

.formBtn{
  text-align: center;
}

.eye{
  position: absolute;
  right: 20px;
  bottom: 14px;
  width: 17px;
  height: 13px;
  cursor: pointer;
}

.eye img{
  width: 17px;
}

.eye img.yes,.text img.no{
  display: none;
}

.text img.yes{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/resetPwd.vue